<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useOperatorFontSize from '@/composables/useOperatorFontSize'

const { t } = useI18n()
const { scale, validScales } = useOperatorFontSize()

const optionLabels = computed(() => [
  t('component.operatorFontSizeSelector.options.small'),
  t('component.operatorFontSizeSelector.options.medium'),
  t('component.operatorFontSizeSelector.options.large'),
  t('component.operatorFontSizeSelector.options.extraLarge'),
])
</script>

<template>
  <v-menu>
    <template #activator="{ props: menuProps }">
      <v-btn v-bind="menuProps" variant="text" append-icon="arrow_drop_down">
        {{ t('component.operatorFontSizeSelector.label') }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(s, i) in validScales" :key="s" :active="s === scale" @click="scale = s">
        <v-list-item-title>{{ optionLabels[i] }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
